// @flow
import styled from 'styled-components';
import Container from '../../components/container';

export const Page = styled(Container)`
  padding-top: 120px;
  position: relative;
  min-height: calc(
    100vh - ${props => props.theme.footerHeight + props.theme.footerMargin}px
  );
`;



// WEBPACK FOOTER //
// ./src/pages/home/home.styles.js